module.exports = __webpack_public_path__ + "img/pro_three_2.18aaff32.jpg";